/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

/**
 * Constant file of method names
 * used in dispatching action in redux store
 */
export const SET_TODAYS_GEOMETRY = "SET_TODAYS_GEOMETRY";
export const SET_FILTERED_GEOMETRY = "SET_FILTERED_GEOMETRY";
export const CLEAR_TODAYS_GEOMETRY = "CLEAR_TODAYS_GEOMETRY";
export const CLEAR_FILTERED_GEOMETRY = "CLEAR_FILTERED_GEOMETRY";

export const SET_VEHICLE = "SET_VEHICLE";
export const SET_COORDINATE = "SET_COORDINATE";

export const SET_AUTH_DATA = "SET_AUTH_DATA";
export const AUTH_SET_TOKEN = "AUTH_SET_TOKEN";

export const SET_VISIT = "SET_VISIT";

export const SET_GEOFENCE = "SET_GEOFENCE";
export const CLEAR_GEOFENCE = "CLEAR_GEOFENCE";

export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";

export const UPDATE_INFO_WINDOW_CHECKBOX = "UPDATE_INFO_WINDOW_CHECKBOX";
export const UPDATE_WORK_ORDER_USER_INFO_BOX_CHECKBOX =
  "UPDATE_WORK_ORDER_USER_INFO_BOX_CHECKBOX";
export const UPDATE_JOB_TYPE_FILTER = "UPDATE_JOB_TYPE_FILTER";
export const UPDATE_USER_FILTER = "UPDATE_USER_FILTER";

export const UPDATE_GEOMETRY_PROPERTIES = "UPDATE_GEOMETRY_PROPERTIES";
export const UPDATE_PROPERTIES = "UPDATE_PROPERTIES";

export const SET_PATH_SAVE_STATUS = "SET_PATH_SAVE_STATUS";

export const SET_USER = "SET_USER";
export const SET_CONTRACTOR = "SET_CONTRACTOR";
